import { put } from 'redux-saga/effects'

import { Game } from '../../../Core'
import LoaderScreen from './index'

function* init() {
  yield loadComponents()
}

/**
 * Load components.
 */
export function* loadComponents() {
  const components = {
    LoaderScreen,
  }

  yield put(Game.actions.registerComponents(components))
}

/**
 * Sagas entrypoint.
 */
export function* sagas() {
  yield init()
}
